"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StatisticsAndSiteScope() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section id="statistics-and-site-scope" className="bg-background">
      <div className="bg-primary py-16 px-4 md:px-6">
        <div className="max-w-2xl mx-auto flex flex-col items-center text-center gap-8">
          <p className="text-[var(--chart-3)] text-xl md:text-2xl font-bold leading-relaxed">
            There are <span className="font-extrabold">120 pages</span>. Encyclopedic!
          </p>

          <Link to="#" className="text-[var(--chart-2)] underline underline-offset-4 font-bold text-lg md:text-xl hover:opacity-80 transition-opacity">
            Begin Here
          </Link>

          <div className="flex flex-col items-center gap-4 mt-4">
            <span className="text-xs text-[var(--chart-3)] font-semibold tracking-wider uppercase">
              26 Feb 2026
            </span>

            <Button variant="outline" size="sm" onClick={scrollToTop} className="bg-transparent text-primary-foreground border-primary-foreground hover:bg-primary-foreground hover:text-primary transition-colors font-bold tracking-widest px-6">
              TOP
            </Button>
          </div>
        </div>
      </div>
    </section>;
}